import { snake } from 'change-case'

export default () => ({
  namespaced: true,

  state: {
    currentPerPage: 50,
    currentPage: 1,
    nextPage: null,
    prevPage: null,
    totalCount: 0,
    totalPages: 1,
  },

  mutations: {
    newState: (state, newState) => {
      Object.keys(state).forEach((key) => {
        state[key] = newState[key] || newState[snake(key)]
      })
    },
  },
})



// WEBPACK FOOTER //
// ./src/store/modules/pagination.js